import { render, staticRenderFns } from "./AddressSearchSuperNew.vue?vue&type=template&id=10e2602c&scoped=true&"
import script from "./AddressSearchSuperNew.vue?vue&type=script&lang=js&"
export * from "./AddressSearchSuperNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2602c",
  null
  
)

export default component.exports